import { ApprovalApprovableState } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

export const getApprovalStateStatusLabel = (status: ApprovalApprovableState) => {
  switch (status) {
    case ApprovalApprovableState.Approved:
      return $t('Approved')
    case ApprovalApprovableState.Rejected:
      return $t('Denied')
    case ApprovalApprovableState.Cancelled:
      return $t('Cancelled')
    case ApprovalApprovableState.Requested:
      return $t('Pending')
    default:
      return $t('Pending')
  }
}
